import React, { useState } from 'react';
import { Modal, Button } from 'antd';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, Loader, X } from 'lucide-react';
import DocumentPages from '../../DocumentPages';
import ChatComponent from './ChatComponent';

const PreviewModal = ({
  isPreviewModalVisible,
  handlePreviewModalCancel,
  selectedDocument,
  pdfFile,
  chatMessages,
  currentPage,
  setCurrentPage,
  handleSendMessage,
  handleClearChat,
  isMobile,
  isStreaming
}) => {
  const [showMobileChat, setShowMobileChat] = useState(false);

  if (isMobile) {
    return (
      <Modal
        title={selectedDocument?.name}
        open={isPreviewModalVisible}
        onCancel={handlePreviewModalCancel}
        width="100%"
        style={{ top: 0, margin: 0, maxWidth: '100%', padding: 0 }}
        styles={{ body: { height: '100vh', padding: 0 } }}
        footer={null}
      >
        <div className="flex flex-col h-full overflow-auto">
          <div className="flex-grow overflow-y-auto relative">
            {pdfFile ? (
              <div className="flex flex-col items-center p-4">
                <DocumentPages
                  selectedDocument={selectedDocument}
                  currentPage={currentPage}
                />
              </div>
            ) : (
              <div className="flex justify-center items-center h-full">
                <Loader /> Loading PDF...
              </div>
            )}
          </div>

          <div className="fixed bottom-4 right-4">
            <Button
              type="primary"
              icon={<MessageCircle />}
              onClick={() => setShowMobileChat(prev => !prev)}
              shape="circle"
              size="large"
            />
          </div>

          <AnimatePresence>
            {showMobileChat && (
              <motion.div
                initial={{ y: '100%' }}
                animate={{ y: 0 }}
                exit={{ y: '100%' }}
                transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                className="fixed inset-0 bg-white z-50"
              >
                <div className="flex flex-col h-full overflow-auto">
                  <div className="p-4 border-b flex justify-between items-center bg-white">
                    <div className="flex items-center space-x-3">
                      <MessageCircle className="w-6 h-6 text-blue-600" />
                      <div>
                        <h4 className="font-semibold">Chat with AI Assistant</h4>
                        <p className="text-sm text-gray-500">Ask questions about the document</p>
                      </div>
                    </div>
                    <Button
                      icon={<X />}
                      onClick={() => setShowMobileChat(false)}
                      type="text"
                    />
                  </div>
                  <ChatComponent
                    messages={chatMessages}
                    onSendMessage={handleSendMessage}
                    onClickPage={(page) => setCurrentPage(Number(page))}
                    onClearChat={handleClearChat}
                    isStreaming={isStreaming}
                  />
                </div>
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      title={selectedDocument?.name}
      open={isPreviewModalVisible}
      onCancel={handlePreviewModalCancel}
      width="95%"
      footer={null}
      style={{ top: 20 }}
      styles={{ body: { padding: 0 } }}
    >
      <div style={{ display: 'flex', height: '85vh' }}>
        <div style={{ flex: 13, borderRight: '1px solid #f0f0f0', overflowY: 'auto', position: 'relative' }}>
          {pdfFile ? (
            <DocumentPages
              selectedDocument={selectedDocument}
              currentPage={currentPage}
            />
          ) : (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%'
            }}>
              <Loader /> Loading PDF...
            </div>
          )}
        </div>
        <div style={{ flex: 7, display: 'flex', flexDirection: 'column', backgroundColor: '#f8fafc' }}>
          <div className="p-6 border-b border-gray-100 bg-white shadow-sm backdrop-blur-sm">
            <div className="flex items-center space-x-4">
              <div className="p-3 bg-gradient-to-br from-blue-50 to-indigo-50 rounded-xl shadow-sm">
                <MessageCircle className="w-6 h-6 text-blue-600" strokeWidth={2} />
              </div>
              <div>
                <h4 className="font-semibold text-xl bg-gradient-to-r from-gray-800 to-gray-600 bg-clip-text text-transparent">
                  Chat with AI Assistant
                </h4>
                <p className="text-sm text-gray-500 mt-0.5">
                  Ask questions or get insights about the document
                </p>
              </div>
            </div>
          </div>
          <ChatComponent
            messages={chatMessages}
            onSendMessage={handleSendMessage}
            onClickPage={(page) => setCurrentPage(Number(page))}
            onClearChat={handleClearChat}
            isStreaming={isStreaming}
          />
        </div>
      </div>
    </Modal>
  );
};

export default PreviewModal;